<template>
    <div>
        <v-layout row>
            <v-flex xs12>
                <v-container grid-list-xl fluid>
                    <v-layout row wrap>
                        <v-flex xs12 class="text-xs-right">
                            <v-btn :to="{name: 'admin.company.team.add', params: {uid: company.uid}}">Add Team Member<v-icon right>person_add</v-icon></v-btn>
                        </v-flex>
                        <v-flex xs12>
                            <ais-instant-search :index-name="indexName" :search-client="searchClient" :routing="routing">
                                <ais-configure :filters="companyTeamFilter"/>
                                <ais-search-box/>
                                <ais-hits>
                                    <v-list
                                            three-line
                                            slot-scope="{ items }"
                                    >
                                        <v-list-tile v-for="item in items" :key="item.objectID" @click="" :to="{name: 'admin.company.team.user.view', params: {uid: uid, team_uid:item.userUID}}">
                                            <v-list-tile-content>
                                                <v-list-tile-title><ais-highlight attribute="userDisplayName" :hit="item" /></v-list-tile-title>
                                                <v-list-tile-sub-title><ais-highlight attribute="userEmail" :hit="item" /></v-list-tile-sub-title>
                                            </v-list-tile-content>
                                        </v-list-tile>
                                    </v-list>
                                </ais-hits>
                                <ais-pagination/>
                            </ais-instant-search>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
  import 'instantsearch.css/themes/algolia-min.css'
  import {SetDocumentTitleMixin, AlgoliaSearchMixin} from '@/views/app/mixins'

  export default {
    name: 'CompanyTeam',
    mixins: [SetDocumentTitleMixin, AlgoliaSearchMixin],
    props: {
      firebaseUser: {
        required: true
      },
      user: {
        required: true
      },
      systemConfig: {
        type: Object,
        required: true
      },
      company: {
        type: Object,
        required: true
      },
      uid: {
        type: String,
        required: true
      }
    },
    created () {
      this.init()
    },
    computed: {
      indexName () {
        return `${this.indexPrefix}CompanyUsers`
      },
      companyUUID () {
        if (this.company.hasOwnProperty('uuid')) {
          return this.company.uuid
        } else {
          return this.company.uid
        }
      },
      companyTeamFilter () {
        return `companyUUID:${this.companyUUID}`
      }
    },
    methods: {
      init () {
        this.setDocumentTitle()
        this.setupSearchClient()
      }
    }
  }
</script>

<style scoped>

</style>